var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "cvadjustexperiences experience-items" },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between mb-3" },
        [
          _c("b-card-title", { staticClass: "h5 mb-0" }, [
            _vm._v(_vm._s(_vm.t.CV_Tool_Adjust_Experiences_Title)),
          ]),
          _c("InfoToolTip", {
            attrs: { content: _vm.t.CV_Tool_Adjust_Experiences_Title_Tooltip },
          }),
          _c(
            "b-link",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom",
                  value: {
                    content: _vm.t.CV_Tool_Profile_Link_Tooltip,
                    container: false,
                  },
                  expression:
                    "{ content: t.CV_Tool_Profile_Link_Tooltip, container: false }",
                  modifiers: { bottom: true },
                },
              ],
              staticClass:
                "text-brand-medium font-weight-bold text-decoration-none",
              style: { height: "fit-content" },
              attrs: { href: _vm.profileLink },
              on: { click: _vm.goToProfile },
            },
            [
              _vm._v(
                _vm._s(_vm.t.general_Add) + " / " + _vm._s(_vm.t.general_Edit)
              ),
            ]
          ),
        ],
        1
      ),
      _c("b-card-text", { staticClass: "text-muted" }, [
        _vm._v(_vm._s(_vm.t.CV_Tool_Adjust_Experiences_Description)),
      ]),
      !_vm.validExperiences ||
      _vm.validExperiences.indexOf("EXPERIENCE_WORK") !== -1
        ? _c("DisplaySkills", {
            staticClass: "mb-3",
            attrs: {
              title: _vm.t.CV_Tool_Adjust_Experiences_Work_Experience,
              items: _vm.items.WorkExperiences,
              type: "WorkExperiences",
              includeDate: true,
              profileLink: _vm.profileLink,
              tooltip: _vm.t.CV_Tool_Skill_Item_Tooltip,
            },
          })
        : _vm._e(),
      !_vm.validExperiences ||
      _vm.validExperiences.indexOf("EXPERIENCE_EDUCATION") !== -1
        ? _c("DisplaySkills", {
            attrs: {
              title: _vm.t.CV_Tool_Adjust_Experiences_Education,
              items: _vm.items.Educations,
              type: "Educations",
              includeDate: true,
              profileLink: _vm.profileLink,
              tooltip: _vm.t.CV_Tool_Skill_Item_Tooltip,
            },
          })
        : _vm._e(),
      !_vm.validExperiences ||
      _vm.validExperiences.indexOf("EXPERIENCE_COURSES") !== -1
        ? _c("DisplaySkills", {
            attrs: {
              title: _vm.t.CV_Tool_Adjust_Experiences_Courses_Certification,
              items: _vm.items.Courses,
              type: "Courses",
              includeDate: true,
              profileLink: _vm.profileLink,
              tooltip: _vm.t.CV_Tool_Skill_Item_Tooltip,
            },
          })
        : _vm._e(),
      !_vm.validExperiences ||
      _vm.validExperiences.indexOf("EXPERIENCE_VOLUNTEER") !== -1
        ? _c("DisplaySkills", {
            attrs: {
              title: _vm.t.CV_Tool_Adjust_Experiences_Volunteer_Work,
              items: _vm.items.VolunteerExperiences,
              type: "VolunteerWork",
              includeDate: true,
              profileLink: _vm.profileLink,
              tooltip: _vm.t.CV_Tool_Skill_Item_Tooltip,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }